import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

/**
 * O que fazer ao ✓ quando se mexe numa marcação já confirmada.
 *
 * ─── PORQUE É UMA PERGUNTA E NÃO UMA REGRA ──────────────────────────────────
 *
 * Mover uma marcação confirmada tem dois significados opostos, e o sistema não
 * os distingue:
 *
 *   · o cliente está ao telefone e pede as 16h em vez das 15h — ele acabou de
 *     confirmar a hora nova, e apagar o ✓ obriga a secretária a ligar outra vez
 *     para confirmar o que confirmou há dez segundos;
 *   · a clínica move por razões dela (o dentista faltou) — o cliente não sabe
 *     de nada, e o ✓ TEM de cair, senão a agenda mente.
 *
 * Quem sabe qual dos dois é, é quem está a mover. Por isso pergunta-se.
 *
 * ─── E AO ELIMINAR NÃO HÁ NADA A MANTER ─────────────────────────────────────
 *
 * Com `modo="eliminar"` é só um aviso: a marcação vai desaparecer e o cliente
 * disse que vinha. A secretária tem de saber que lhe deve um telefonema.
 */
function DialogoConfirmacaoAgendamento({
  aberto,
  modo = "mover", // "mover" | "eliminar"
  nomeCliente,
  aoManter,
  aoRetirar,
  aoCancelar,
}) {
  const quem = nomeCliente || "O cliente";

  return (
    <Dialog open={aberto} onClose={aoCancelar} maxWidth="xs" fullWidth>
      <DialogTitle>
        {modo === "eliminar"
          ? "Esta marcação está confirmada"
          : "O cliente já tinha confirmado"}
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          {modo === "eliminar" ? (
            <>
              <strong>{quem}</strong> confirmou que vinha. Se eliminar a
              marcação, ele aparece e não há nada marcado — convém telefonar-lhe.
            </>
          ) : (
            <>
              <strong>{quem}</strong> confirmou a data e a hora que estão a
              mudar. Já falou com ele sobre a data nova?
            </>
          )}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={aoCancelar}>Cancelar</Button>

        {modo === "eliminar" ? (
          <Button onClick={aoRetirar} variant="contained" color="error">
            Eliminar na mesma
          </Button>
        ) : (
          <>
            {/* «Retirar» primeiro e em destaque: é o caso mais comum e o mais
                seguro. Manter o ✓ é dizer que já se falou com a pessoa. */}
            <Button onClick={aoRetirar} variant="contained" color="error">
              Não — retirar a confirmação
            </Button>
            <Button onClick={aoManter} variant="outlined" color="success">
              Já falei — manter
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default DialogoConfirmacaoAgendamento;
